
const style = document.createElement('style');

style.innerHTML = `

.native-size-current {
  font-weight:300!important;
}



.opt-label.opt-label--swatch.is-unavailable{
  opacity:1!important;
  filter:none!important;
}

.opt-label.opt-label--swatch.is-unavailable::before{
  background-image:none!important;
  opacity:1!important;
  filter:none!important;
}


/* Shopify sold out swatch */
.opt-label.opt-label--swatch.is-unavailable::before{
  background-image:none!important;
}

`;

document.head.appendChild(style);



(function() {

  function updateNativeSizeLabel() {
    document.querySelectorAll('.option-selector').forEach(function(optionBox) {
      const legend = optionBox.querySelector('legend');
      if (!legend) return;

      const title = legend.innerText.trim().toLowerCase();
      if (!title.startsWith('size')) return;

      const checked = optionBox.querySelector('input:checked');
      if (!checked) return;

      let current = legend.querySelector('.native-size-current');

      if (!current) {
        legend.innerHTML = '';

        const strong = document.createElement('strong');
        strong.className = 'native-size-title';
        strong.innerText = 'Size:';
        legend.appendChild(strong);

        current = document.createElement('span');
        current.className = 'native-size-current';
        
        legend.appendChild(document.createTextNode(' '));
        legend.appendChild(current);
      }

      current.innerText = checked.value;
    });
  }

  document.addEventListener('change', function(e) {
    if (e.target.closest('.option-selector')) {
      setTimeout(function() {
        updateNativeSizeLabel();
      }, 100);
    }
  });

  setTimeout(function() {
    updateNativeSizeLabel();
  }, 500);

})();